import { Controller } from "stimulus"
import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo

export default class extends Controller {
  static targets = [ "sub", "sku", "loader", "entries", "link", "pagination", "bottomloader" ]
  static values = {
    next: String
  }

  connect() {
    console.log('**** price history')

    // this.loaderTarget.classList.remove('hidden')

    // if (this.hasEntriesTarget){
    //   console.log('ocultando loader...')
    //   this.loaderTarget.classList.add('hidden')
    // }

    // setInterval(() => {
    //   this.loaderTarget.classList.add('hidden')
    // }, 1000)
  }

  search_sku(event) {
    if (event.keyCode === 13) {
      console.log(`${this.sku}`)
      console.log('Se mandó a buscar')

      this.loaderTarget.classList.remove('hidden')

      // No usar parametros con ? porque no funcionan en IOS
      let url = `${window.location.origin}/historial/${this.sku}`

      Turbo.visit(url, { action: "advance" })
    }
  }

  get sku() {
    return this.skuTarget.value
  }

  get sub() {
    return this.subTarget.value
  }
}
